import { Box, Stack, Typography, Paper, Avatar, Button } from '@mui/material';
import Timer from '../Timer';
import ShareIcon from '@mui/icons-material/Share';
import LogoutIcon from '@mui/icons-material/Logout';

// Props are now named to match the state in Game.js
export default function MultiplayerPlayerBar({ myTime, setMyTime, turn, gameMode, gameState, setDrawConfirmation, setResignConfirmation, onExport, onExit }) {
    return (
        <Paper elevation={3} sx={{ p: { xs: 0.5, sm: 1 }, width: '100%', backgroundColor: '#2a343b', color: 'white' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                {/* Left: Buttons */}
                {gameState === 'afterGame' ? (
                    <Stack direction="row" spacing={{ xs: 1, sm: 2 }} sx={{ mx: { xs: 0, sm: 'auto' }, width: { xs: '100%', sm: 'auto' }, justifyContent: { xs: 'center', sm: 'flex-start' } }}>
                        <Button className='btn2' size="small" onClick={onExport} endIcon={<ShareIcon />}>
                            Analysis
                        </Button>
                        <Button className='btn2' size="small" onClick={onExit} endIcon={<LogoutIcon />}>
                            Exit
                        </Button>
                    </Stack>
                ) : (
                    <>
                        <Stack direction="row" spacing={1} sx={{ ml: { xs: 1, sm: 4 } }}>
                            <Button size="small" variant="outlined" color="inherit" onClick={() => setResignConfirmation(true)}>Resign</Button>
                            <Button size="small" variant="outlined" color="inherit" onClick={() => setDrawConfirmation(true)}>Draw</Button>
                        </Stack>
                        {/* Right: Avatar, Name, Mode, and Timer */}
                        <Stack direction="row" spacing={{ xs: 1, sm: 1.5 }} alignItems="center" sx={{ mr: { xs: 1, sm: 2 } }}>
                            <Avatar sx={{ bgcolor: 'secondary.main', width: 32, height: 32, fontSize: { xs: '1rem', sm: '1.2rem' } }}>You</Avatar>
                            <Typography variant="body2" sx={{ fontSize: { xs: '0.95rem', sm: '1rem' } }}>
                                You ({gameMode})
                            </Typography>
                            <Timer
                                minSecs={myTime}
                                setTime={setMyTime}
                                isRunning={turn && gameState === 'start'}
                            />
                        </Stack>
                    </>
                )}
            </Box>
        </Paper>
    );
}
